var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMargin08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 123,
    viewBox: "0 0 203 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M173.79 51.9594V100.759H2V23.8594H173.79V37.8994",
    stroke: "black",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M73.4297 39.9395H142.71",
    stroke: "black",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M73.4297 50.6191H142.71",
    stroke: "black",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M73.4297 61.3086H142.71",
    stroke: "black",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M73.4297 72H128.8",
    stroke: "black",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M73.4297 82.6895H128.8",
    stroke: "black",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M37.2302 85.3784C50.3415 85.3784 60.9702 74.7497 60.9702 61.6384C60.9702 48.5272 50.3415 37.8984 37.2302 37.8984C24.119 37.8984 13.4902 48.5272 13.4902 61.6384C13.4902 74.7497 24.119 85.3784 37.2302 85.3784Z",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M44.441 53.6473C44.441 53.6473 41.781 51.0273 37.781 51.0273C33.781 51.0273 31.631 53.0273 31.631 56.0773C31.631 59.1273 34.731 60.3873 38.041 61.4073C41.351 62.4273 43.971 64.0373 43.971 66.6773C43.971 69.3173 41.431 71.5973 37.791 71.5973C34.151 71.5973 30.041 68.6473 30.041 68.6473",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M37.7812 46.6582V76.6182",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M146.13 79.4591L132.76 85.9791L139.28 72.6091L192.54 19.3491C194.43 17.4591 197.49 17.4591 199.39 19.3491C201.28 21.2391 201.28 24.2991 199.39 26.1991L146.13 79.4591Z",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M186.789 25.1094L193.629 31.9594",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M139.289 72.6094L146.129 79.4594",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M165.731 78.75C168.471 78.75 168.471 74.5 165.731 74.5C162.991 74.5 162.991 78.75 165.731 78.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M80.93 14.8398C83.67 14.8398 83.67 10.5898 80.93 10.5898C78.19 10.5898 78.19 14.8398 80.93 14.8398Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M58.68 113.24C61.42 113.24 61.42 108.99 58.68 108.99C55.94 108.99 55.94 113.24 58.68 113.24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M77.4105 113.08C80.1505 113.08 80.1505 108.83 77.4105 108.83C74.6705 108.83 74.6705 113.08 77.4105 113.08Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M104.171 12.72C107.131 12.72 109.531 10.3202 109.531 7.36C109.531 4.39975 107.131 2 104.171 2C101.21 2 98.8105 4.39975 98.8105 7.36C98.8105 10.3202 101.21 12.72 104.171 12.72Z",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M109.53 120.79C112.49 120.79 114.89 118.391 114.89 115.43C114.89 112.47 112.49 110.07 109.53 110.07C106.57 110.07 104.17 112.47 104.17 115.43C104.17 118.391 106.57 120.79 109.53 120.79Z",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMargin08);
export default __webpack_public_path__ + "static/media/icon_margin_08.0dfcdf73f800a3d0e5e82155776b63e9.svg";
export { ForwardRef as ReactComponent };